import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { getAllClient } from "./client_halper";
import { Box, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Done, WarningAmber } from "@mui/icons-material";
import { green, orange } from "@mui/material/colors";
import ClientDetails from "./client_details";
import Loading1 from "../frames/loading1";
import ClientEdit from "./client_edit";
import { useNavigate } from "react-router-dom";
import HtmlTooltip from "../frames/html_tooltip";

const next_line = (str) => {
    if (str === null || str === "") return true;
    return null;
}

function ClientList() {
    const [clientList, setClientList] = useState(null);
    const [activeClient, setActiveClient] = useState(null);
    const [isViewClient, setIsViewClient] = useState(false);
    const [isEditClient, setIsEditClient] = useState(false);
    const navigator = useNavigate();

    const handleClientEdit = (client) => {
        for (let idx = 0; idx < clientList.length; idx++) {
            const element = clientList[idx];
            if (element.client_id === activeClient.client_id) {
                clientList[idx] = client;
                setClientList(clientList);
                setActiveClient(null);
                break;
            }
        }
    }

    const handleClose = (action) => {
        if (action === "edit") {
            setIsViewClient(false);
            setIsEditClient(true);
        } else {
            setActiveClient(null);
            setIsViewClient(false);
            setIsEditClient(false);
        }
    };

    if (clientList === null) {
        getAllClient().then((res) => {
            setClientList(res);
        }).catch((err) => {
            console.error(err);
        });
    };

    const isEmptyShipping = (row) => {
        return row.shipping_add_1 || row.shipping_add_2 || row.shipping_add_3 || row.shipping_add_state || row.shipping_add_zip;
    };

    const isEmptyBilling = (row) => {
        return row.billing_add_1 || row.billing_add_2 || row.billing_add_3 || row.billing_add_state || row.billing_add_zip;
    };

    return (
        <MenuFrame permission="CLIENT">
            <ClientDetails open={isViewClient} client={activeClient} handleClose={handleClose} />
            <ClientEdit open={isEditClient} client={activeClient} onSuccess={handleClientEdit} onClose={handleClose} />
            <Box sx={{ py: 2 }}>
                <Chip label="New Client" variant="filled" color="info" onClick={() => { navigator("/client/new"); }} />
            </Box>
            {clientList === null ? <Loading1 /> :
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="client list" className="nowrap">
                        <TableHead>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                                <TableCell>Client #</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell align="right">GST</TableCell>
                                <TableCell align="right">Phone</TableCell>
                                <TableCell>Mail</TableCell>
                                <TableCell>Created</TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {clientList.map((row) => (
                                <TableRow
                                    key={row.client_id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    onClick={(e) => {
                                        setActiveClient(row);
                                        setIsViewClient(true);
                                        setIsEditClient(false);
                                    }}
                                >
                                    <TableCell component="th" scope="row">{row.client_id}</TableCell>
                                    <TableCell>
                                        <HtmlTooltip title={isEmptyShipping(row) ? <Typography variant="caption">{row.shipping_add_1}{next_line(row.shipping_add_2) ?? <br />}{row.shipping_add_2}{next_line(row.shipping_add_3) ?? <br />}{row.shipping_add_3}{next_line(row.shipping_add_state) ?? <br />}{row.shipping_add_state} {next_line(row.shipping_add_zip) ?? "-"} {row.shipping_add_zip}</Typography> : ""}>
                                            <Typography variant="body2">{row.name}</Typography>
                                        </HtmlTooltip>
                                    </TableCell>
                                    <TableCell align="right">
                                        <HtmlTooltip title={isEmptyBilling(row) ? <Typography variant="caption">{row.billing_add_1}{next_line(row.billing_add_2) ?? <br />}{row.billing_add_2}{next_line(row.billing_add_3) ?? <br />}{row.billing_add_3}{next_line(row.billing_add_state) ?? <br />}{row.billing_add_state} {next_line(row.billing_add_zip) ?? "-"} {row.billing_add_zip}</Typography> : ""}>
                                            <Typography variant="body2">{row.gst_num ?? <WarningAmber fontSize="small" htmlColor={orange[100]} />}</Typography>
                                        </HtmlTooltip>
                                    </TableCell>
                                    <TableCell align="right"><Typography variant="body2">{row.phone ?? <WarningAmber fontSize="small" htmlColor={orange[100]} />}</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{row.email ?? <WarningAmber fontSize="small" htmlColor={orange[100]} />}</Typography></TableCell>
                                    <TableCell noWrap><Typography variant="body2">{row.created}</Typography></TableCell>
                                    <TableCell><Typography variant="body2">{row.status === 'Active' ? <Done fontSize="small" htmlColor={green[500]} /> : row.status}</Typography></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </MenuFrame>
    );
}

export default ClientList;